import { TurnstileWidget } from '@kompare/captcha-react';
import React from 'react';
import { CaptchaState, i18n } from 'src/common';
import { colors } from 'src/theme';
import { Flex, Text } from '..';

/**
 * The Turnstile widget plus its copy, rendered above a form's submit button while a
 * challenge is due. Spread the `captcha` object from `useCreateSoWithCaptcha` into it;
 * it renders nothing until the API has asked for a captcha, so regular visitors never
 * load Cloudflare's script.
 */
export const CaptchaChallenge = ({ required, message, widgetProps }: CaptchaState) => {
  if (!required) return null;
  return (
    <Flex vertical gap={8}>
      <TurnstileWidget
        {...widgetProps}
        loadErrorFallback={
          <Text type="small" color={colors.error1} style={{ textAlign: 'center' }}>
            {i18n.t('common.globalError')}
          </Text>
        }
      />
      {message && (
        <Text type="small" color={colors.error1} style={{ textAlign: 'center' }}>
          {message}
        </Text>
      )}
    </Flex>
  );
};
